import request from "@/utils/request"
// 获取街道列表
export function getStreetPageList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/Street/GetPageList",
    method: "get",
    params
  })
}
// 修改街道
export function modifyStreet(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Street/Update",
    method: "post",
    data
  })
}
// 删除街道
export function delStreet(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Street/Delete",
    method: "post",
    data
  })
}
// 新增街道
export function addStreet(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Street/Add",
    method: "post",
    data
  })
}
// 获取设备枪列表
export function getChargeGunPageList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargeGun/GetPageList",
    method: "get",
    params
  })
}
// 修改设备枪
export function modifyChargeGun(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargeGun/Update",
    method: "post",
    data
  })
}
// 删除设备枪
export function delChargeGun(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargeGun/Delete",
    method: "post",
    data
  })
}
// 新增设备枪
export function addChargeGun(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargeGun/Add",
    method: "post",
    data
  })
}
// 获取桩厂家列表
export function getChargePileProducerList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/ChargePileProducer/GetPageList",
    method: "get",
    params
  })
}
// 修改桩厂家
export function modifyChargePileProducer(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/ChargePileProducer/Update",
    method: "post",
    data
  })
}
// 删除桩厂家
export function delChargePileProducer(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/ChargePileProducer/Delete",
    method: "post",
    data
  })
}
// 添加桩厂家
export function addChargePileProducer(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/ChargePileProducer/Add",
    method: "post",
    data
  })
}
// 获取社区列表
export function getCommunityList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/Community/GetPageList",
    method: "get",
    params
  })
}
// 修改社区
export function modifyCommunity(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Community/Update",
    method: "post",
    data
  })
}
// 删除社区
export function delCommunity(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Community/Delete",
    method: "post",
    data
  })
}
// 添加社区
export function addCommunity(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/Community/Add",
    method: "post",
    data
  })
}

// 同步分支箱库存（从恒电聚能同步）
export function tongbuKcBranchBox() {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/TongbuKcBranchBox",
    method: "get",
    params: null
  })
}
// 获取分支箱列表
export function getPowerBranchBoxList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/GetPageList",
    method: "post",
    data
  })
}
// 获取费控表
export function GetFeeTablelist(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/GetFeeTablelist",
    method: "get",
    params
  })
}
// 修改分支箱
export function modifyPowerBranchBox(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/Update",
    method: "post",
    data
  })
}
// 删除分支箱
export function delPowerBranchBox(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/Delete",
    method: "post",
    data
  })
}
// 添加分支箱
export function addPowerBranchBox(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerBranchBox/Add",
    method: "post",
    data
  })
}

// 同步一体柜库存（从恒电聚能同步）
export function tongbuKcCabinet() {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerCabinet/TongbuKcCabinet",
    method: "get",
    params: null
  })
}

// 获取一体柜配置
export function GetSetParamPowerCabinet(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerCabinet/GetSetParamByCabinetId",
    method: "get",
    params
  })
}
// 保存一体柜
export function SaveSetParamPowerCabinet(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerCabinet/SaveSetParam",
    method: "post",
    data
  })
}
// 下发一体柜
export function PushSetParamPowerCabinet(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerCabinet/PushSetParam",
    method: "post",
    data
  })
}
// 获取一体柜列表
export function getPowerCabinetList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerCabinet/GetPageList",
    method: "post",
    data
  })
}
// 修改一体柜
export function modifyPowerCabinet(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerCabinet/Update",
    method: "post",
    data
  })
}
// 删除一体柜
export function delPowerCabinet(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerCabinet/Delete",
    method: "post",
    data
  })
}
// 添加一体柜
export function addPowerCabinet(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerCabinet/Add",
    method: "post",
    data
  })
}

// 获取台区列表
export function getPowerTransformerList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerTransformer/GetPageList",
    method: "post",
    data
  })
}
// 修改台区
export function modifyPowerTransformer(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerTransformer/Update",
    method: "post",
    data
  })
}
// 删除台区
export function delPowerTransformer(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerTransformer/Delete",
    method: "post",
    data
  })
}
// 添加台区
export function addPowerTransformer(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerTransformer/Add",
    method: "post",
    data
  })
}
// 台区配置
export function GetSetParamByTransformerId(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerTransformer/GetSetParamByTransformerId",
    method: "get",
    params
  })
}
//保存台区配置
export function SaveSetParam(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerTransformer/SaveSetParam",
    method: "post",
    data
  })
}
// 发送台区配置
export function PushSetParam(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerTransformer/PushSetParam",
    method: "post",
    data
  })
}
// 获取省市区
export function GetAllList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/DeployDistrict/GetAllList",
    method: "post",
    data
  })
}
// 获取三元信息
export function GetTripletPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/MainDbArchvie/GetTripletPageList",
    method: "post",
    data
  })
}
// 获取三元信息
export function GetTjtfTripletPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/MainDbArchvie/GetTjtfTripletPageList",
    method: "post",
    data
  })
}
//获取桩列表
export function getPowerChargePileList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargePile/GetPageList",
    method: "get",
    params
  })
}
//修改桩
export function modifyPowerChargePile(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargePile/Update",
    method: "post",
    data
  })
}
//删除桩

export function delPowerChargePile(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargePile/Delete",
    method: "post",
    data
  })
}
//添加站点

export function addPowerChargePile(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargePile/Add",
    method: "post",
    data
  })
}
//查找站点
export function GetPageListForAdd(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargePile/GetPageListForAdd",
    method: "get",
    params
  })
}
//获取运行日志列表
export function GetPageListLog(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevRunLog/GetPageList?t=837d",
    method: "post",
    data
  })
}
//获取策略详情列表
export function getPageSpecialControl(data) {
  return request({
    url: "/Anno.Plugs.PowerControl/SpecialControl/GetPageList",
    method: "post",
    data
  })
}
//发送策略详情

export function SendOrderSpecialControl(data) {
  return request({
    url: "/Anno.Plugs.PowerControl/SpecialControl/SendOrder",
    method: "post",
    data
  })
}
//下发策略详情

export function pushPageSpecialControl(data) {
  return request({
    url: "/Anno.Plugs.PowerControl/SpecialControl/PushSpecialOrder",
    method: "post",
    data
  })
}
//获取策略详情

export function GetParamsBySpecialControlId(params) {
  return request({
    url: "/Anno.Plugs.PowerControl/SpecialControl/GetParamsBySpecialControlId",
    method: "get",
    params
  })
}
//删除策略详情

export function deletePageSpecialControl(data) {
  return request({
    url: "/Anno.Plugs.PowerControl/SpecialControl/Delete",
    method: "post",
    data
  })
}
//新增策略详情
export function addPageSpecialControl(data) {
  return request({
    url: "/Anno.Plugs.PowerControl/SpecialControl/add",
    method: "post",
    data
  })
}
//策略详情发送执行
export function SendOrderBySpecialControlId(params) {
  return request({
    url: "/Anno.Plugs.PowerControl/SpecialControl/SendOrderBySpecialControlId",
    method: "get",
    params
  })
}
//获取资产码列表
export function getOnlinePageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetOnlinePageList",
    method: "post",
    data
  })
}
//获取设备状态详情数据
export function GetDevExtInfo(params) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevExtInfo",
    method: "get",
    params
  })
}
//获取台区监测左侧树形图
export function GetLeftTree(params) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetLeftTree?t=120",
    method: "get",
    params
  })
}
//获取台区树形
export function GetTransformerTree(params) {
  return request({
    url: "Anno.Plugs.DevRun/DevDataView/GetTransformerTree",
    method: "get",
    params
  })
}
//获取站点列表
export function getPowerSiteList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSite/GetPageList",
    method: "post",
    data
  })
}
//修改站点
export function modifyPowerSite(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSite/Update",
    method: "post",
    data
  })
}
//删除站点
export function delPowerSite(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSite/Delete",
    method: "post",
    data
  })
}
//新增站点
export function addPowerSite(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSite/Add",
    method: "post",
    data
  })
}
//获取站点列表
export function GetSendOrderLogPageList(data) {
  return request({
    url: "Anno.Plugs.DevRun/DevDataView/GetSendOrderLogPageList",
    method: "post",
    data
  })
}

// 获取三元详情
export function GetTripletByAssetsCode(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/Triplet/GetTripletByAssetsCode",
    method: "get",
    params
  })
}

/**
 * 获取换表记录列表数据
 * @param {*} data
 * @returns
 */
export function getFeetableSwitchPageListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/GeFeetableSwitchPageList",
    method: "post",
    data
  })
}

/**
 * 根据ID获取换表工单详情数据
 * @param {*} params
 * @returns
 */
export function getFeetableSwitchInfoApi(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/GetFeetableSwitchInfo",
    method: "get",
    params
  })
}

/**
 * 获取调控明细列表数据
 * @param {*} data
 * @returns
 */
export function getCtrDetailPageListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/CtrStrateRunDetail/GetPageList",
    method: "post",
    data
  })
}

/**
 * 获取费控表公共通道列表数据
 * @param {*} data
 * @returns
 */
export function getFeeTableIsPubPageListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/FeeTable/GetFeeTableIsPubPageList",
    method: "post",
    data
  })
}

/* ==================== 台区总览 ==================== */

// 获取区域级联树（一次性返回省/市/区县/街道/社区/站点，level：0~5，节点含 id/label/Text/children）
export function getRegionTreeApi() {
  return request({
    url: "/Anno.Plugs.DevRun/TransformerView/GetRegionTree",
    method: "get"
  })
}

// 查询指定区域下的台区总览列表（参数：level、region_id，level 为选中区域的层级 0~5）
export function getTqViewPageListApi(data) {
  return request({
    url: "/Anno.Plugs.DevRun/TransformerView/GetTqViewPagelist",
    method: "post",
    data
  })
}

// 查询台区总览统计数据（统计当前搜索条件下的台区及设备数据）
// 参数：level + region_id（未选择区域时不传）
// 返回：total_count 台区总数、cabinet_count 一体柜数量、branch_box_count 分支箱数量、
//       fee_meter_capacity 费控表容量、installed_fee_meter_count 已装费控表数、
//       bound_user_count 已绑用户、remain_bind_user_count 剩余可绑用户
// 说明：接口路径为约定的假路径，待后端实现
export function getTransformerOverviewStatisticApi(data) {
  return request({
    url: "/Anno.Plugs.DevRun/TransformerView/GetTqViewStatisticSummary",
    method: "post",
    data
  })
}

// 查询台区拓扑数据（返回该台区的拓扑树，含节点详细信息）
export function getTransformerTopoDataApi(params) {
  return request({
    url: "/Anno.Plugs.DevRun/TransformerView/GetTopoData",
    method: "get",
    params
  })
}

// 查询台区拓扑树中某一节点的详细数据
export function getTopoNodeItemDetailApi(data) {
  return request({
    url: "/Anno.Plugs.DevRun/TransformerView/GetTopoData_ItemDetail",
    method: "post",
    data
  })
}

// 根据分支箱ID获取其下的费控表数据信息
export function getFeeTablelistApi(params) {
  return request({
    url: "/Anno.Plugs.DevRun/TransformerView/GetFeeTablelist",
    method: "get",
    params
  })
}

// 查询费控表监测数据（电压/电流/功率 24 小时曲线）
export function getFeeMeterMonitorDataApi(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetAcHisList",
    method: "post",
    data
  })
}

// 按资产码 + 时间段查询设备 AC 历史数据（一体柜/分支箱三相监测曲线共用同一接口）
// 参数：assetsCode、start_time、end_time（yyyy-MM-dd HH:mm:ss）
export function getAcHisListApi(data) {
  return request({
    //url: "/Anno.Plugs.DevRun/TransformerView/GetAcHisList",
    url: "/Anno.Plugs.DevRun/DevDataView/GetPlatFormHisList",
    method: "post",
    data
  })
}

// 保存 KS 终端设置（接口为约定的假路径，待后端实现）
// 参数：transformer_id、triplet_id、assetsCode、report_interval、switch_report_interval
export function saveKsTerminalConfigApi(data) {
  return request({
    url: "/Anno.Plugs.DevRun/TransformerView/SetKsTerminalConfig",
    method: "post",
    data
  })
}

/* ==================== KS 终端管理（接口为约定的假路径，待后端实现） ==================== */

// 分页查询 KS 终端列表
// 参数：page、pagesize、factory_no、transformer_name、cabinet_name、name、sim_no
export function getKsDeviceListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/KsDevice/GetPageList",
    method: "post",
    data
  })
}

// 新增 KS 终端
// 参数：name、factory_no、transformer_id、cabinet_id、remark
export function addKsDeviceApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/KsDevice/Add",
    method: "post",
    data
  })
}

// 修改 KS 终端
// 参数：ID、name、factory_no、transformer_id、cabinet_id、remark、report_interval、switch_report_interval
export function updateKsDeviceApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/KsDevice/Update",
    method: "post",
    data
  })
}

// 删除 KS 终端
// 参数：ID
export function deleteKsDeviceApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/KsDevice/Delete",
    method: "post",
    data
  })
}
